// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"283a88cf","513":"6c97df70","703":"facd3a7b","787":"7db671ad"}[chunkId] + ".chunk.js";
};